import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import "keen-slider/keen-slider.min.css";
import styled from "@emotion/styled";
import { SliderCarousel } from "./SliderCarousel";
import { useElementsContext } from "../elementsProvider";
import { CardCarousel } from "./CardCarousel";
import { placeholderProductsInfo } from "./placeholderProductsInfo";
import { deletedProduct } from "./deletedProduct";
export function RTCProductsCarousel({ colorTexts, subelements, typographyTexts, }) {
    const { isMobile, context } = useElementsContext();
    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const sliderSize = products.length;
    useEffect(() => {
        setIsLoading(true);
        const ids = [];
        const productsIDs = [];
        const placeholderIDs = [];
        subelements.forEach(({ productId }) => {
            if (productId.includes("placeholder")) {
                placeholderIDs.push(productId);
            }
            else {
                productsIDs.push(productId);
            }
            ids.push(productId);
        });
        const apiUrl = context === "ecommerce"
            ? `${process.env.REACT_APP_API}/v1/${window.STORE_ID}/designer/products/?ids=`
            : `${process.env.REACT_APP_SERVER_URL}/api/v4/publications/SP/publications/?ids_eq=`;
        if (productsIDs.length <= 0) {
            const result = [];
            ids.forEach(id => {
                result.push(placeholderProductsInfo[id]);
            });
            setProducts(result);
            setIsLoading(false);
        }
        if (productsIDs.length > 0) {
            fetch(apiUrl + productsIDs.join(","))
                .then(response => response.json())
                .then((response) => {
                const result = [];
                ids.forEach((id, index) => {
                    if (placeholderIDs.includes(id)) {
                        result.push(placeholderProductsInfo[id]);
                    }
                    else {
                        const product = response.objects.find(product => product.identifier === id);
                        if (context === "ecommerce" &&
                            product != null &&
                            product.status !== "PA") {
                            result.push(product);
                        }
                        if (context === "editor") {
                            result.push(product || Object.assign(Object.assign({}, deletedProduct["deleted"]), { identifier: `deleted${index}` }));
                        }
                    }
                });
                setProducts(result);
            })
                .catch(console.error)
                .finally(() => setIsLoading(false));
        }
    }, [context, subelements]);
    if (isLoading) {
        //TODO: reemplazar por loading cuando este definido
        return null;
    }
    if (products.length <= 0) {
        return null;
    }
    const cardsPerSlide = isMobile ? 1 : 4;
    const isSliderActive = sliderSize > cardsPerSlide;
    if (!isSliderActive) {
        return (_jsx(CardsContainer, Object.assign({ isDesktop: !isMobile }, { children: products === null || products === void 0 ? void 0 : products.map(subelement => (_jsx(CardCarousel, { subelement: subelement, colorTexts: colorTexts, typographyTexts: typographyTexts, isMobile: isMobile, cardWidth: isMobile ? 268 : 328, isSliderActive: isSliderActive, context: context }, subelement.identifier))) }), void 0));
    }
    return (_jsx(SliderCarousel, { colorTexts: colorTexts, skin: "1", products: products, typographyTexts: typographyTexts, cardsPerSlide: cardsPerSlide, isSliderActive: isSliderActive }, void 0));
}
const CardsContainer = styled.section(({ isDesktop }) => (Object.assign({ display: "grid", alignItems: "center", gridAutoFlow: "column", justifyContent: "center", gridGap: "0.8rem", padding: "0.8rem 0px" }, (isDesktop
    ? {
        gridGap: "1.6rem",
        width: "100%",
        gridAutoColumns: "auto",
    }
    : {}))));
//# sourceMappingURL=RTCProductsCarousel.js.map